import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { Collapse } from 'react-bootstrap';
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import Icons from '../../../../../icon';
import { ORDER_STATUS, CIRCUIT_STATUS } from '../../../../../../constants/external-constants';

export class ChangeUserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUserDetails: false
        };
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }
    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (parseInt(endUserId) === parseInt(employeeId));

        return editableRequest && isRequestOwner && !path;
    }
    render() {
        const { openRequestModal, data, path } = this.props;
        const requestType = data?.Order?.RequestType || {};
        const RequestTypeID = requestType.RequestTypeID;
        const RequestType = requestType.RequestType;
        const OrderStatusId = data?.Order?.OrderStatusId;
        const EndUserId = data?.Order?.EndUserId;
        const RequestorId = data?.Order?.RequestorId;

        const subscription = data?.Subscription || {};
        const newUser = data?.NewRequest?.User || {};
        const newUserLocation = newUser.Location || {};
        var employeeId = sessionStorage.getItem('EmployeeID');
        var IsROB = ((parseInt(employeeId) !== parseInt(data.RequestedInBeHalfOf.EmployeeId)))
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?  
                           <Icons
                           customClassName="pen-to-square"
                           name="pen-to-square"
                           size="20px"
                           containerClass="icon-circle-plus-container"
                           onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                           labelValue={"Update Order Request"}
                           labelClass="order-detail-edit-label"                                                              
                       />
                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data?.Order?.OrderNumber}
                        </div>
                    </div>
                    {IsROB ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={IsROB} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data?.Circuit?.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={subscription.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : subscription.CircuitStatus === CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{subscription?.PlanDetails?.PlanName ?
                                    subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{subscription.SubscriptionDetailDevice ?
                                    subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">TRANSFER TO NEW SUBSCRIBER</h5>
                    {/* <h5 className="order-detail-location-title"><Translation translationKey="transfer_to" /></h5> */}
                    {/* <h5 className="order-detail-location-title"><Translation translationKey="new_subscriber" /></h5> */}
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="name" /></td>
                                <td>{newUser.LastName}, {newUser.FirstName} {newUser.MiddleName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                 <td>
                                    <a onClick={() => this.setState({ showUserDetails: !this.state.showUserDetails })} className="order-action-link">
                                    {this.state.showUserDetails ? <Translation translationKey="hide_details" /> : <Translation translationKey="show_details" />}
                                    </a>
                                    <Collapse in={this.state.showUserDetails}>
                                        <div className="request-details-hidden-sec">
                                            <p className="request-details-sec-val">{newUser.Email}</p>
                                            <p className="request-details-sec-val">{newUserLocation.LocationSite + " - " + newUserLocation.LocationCity + ", " + newUserLocation.CountryName}</p>
                                        </div>
                                    </Collapse>
                                </td> 
                            </tr>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data?.BusinessJustification?.PurposeOfUse}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_case" /></td>
                                <td>{data?.BusinessJustification?.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data?.BusinessJustification?.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data?.BusinessJustification?.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}